module.exports = "<symbol id=\"tt-icon-delete\" viewBox=\"0 0 24 24\"><path d=\"M3.34 21.28a2.48 2.48 0 0 0 2.47 2.47h12.37a2.48 2.48 0 0 0 2.47-2.47V6.43H3.34zM5.82 8.91h12.36v12.37H5.82zm9.89-6.18h7.42V5.2H.87V2.72h7.42V.25h7.42zm-7.42 8.65v7.42h2.47v-7.42zm4.95 0v7.42h2.47v-7.42z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/delete.svg
// module id = 166
// module chunks = 11